import SpriteSymbol from "../../../node_modules/svg-sprite-loader/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-city",
  "use": "icon-city-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-city\"><defs><style type=\"text/css\"></style></defs><path d=\"M401.520341 330.794374L20.342629 184.849829v839.150171H185.901822V563.382898h215.618519v-232.588524zM817.921604 26.750432h-54.43162V0H628.963444V26.750432h-54.441627v997.249568h133.029076V652.087297h110.370711V26.750432z\" p-id=\"36112\" fill=\"#ffffff\" /><path d=\"M734.62784 690.164411h243.397285v333.835589h-243.397285V690.164411zM482.232012 593.483546H210.927106v430.516454H549.496533V536.315959h-67.264521v57.167587z\" p-id=\"36113\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/city.svg
// module id = aOYn
// module chunks = 7